
  export default {
    props: ['email','tel','dublon'],
  }
  